import { createFeatureSelector } from '@ngrx/store';
import { USER, LoginState, ERROR } from './login.state';

export const getUserState = createFeatureSelector<LoginState>(USER);
export const getErrorState = createFeatureSelector<LoginState>(ERROR);
